import { action, makeObservable, observable } from 'mobx';

import { agent } from 'src/api/agent';
import { hasValue } from 'src/packages/utils/has-value';

import type { LocalizationService } from '../../localization-service.ts/index.js';
import type { DirectoryRecord } from '../entities/directory-record.entity.js';
import type { TControlView } from '../types/index.js';

import { ValidationServiceApi } from './validation-serivce-api.js';

export class ValidationService {
  private readonly api: ValidationServiceApi;
  private readonly localizationService: LocalizationService;
  private readonly controlViewsMap = new Map<string, TControlView>();
  @observable requiredFieldNames: string[] = [];
  // Динамический признак обязательности конкретной ячейки
  requiredFields = observable.map<string, boolean>();

  constructor(localizationService: LocalizationService) {
    this.localizationService = localizationService;
    this.api = new ValidationServiceApi(agent);

    makeObservable(this);
  }

  private validateFieldRequiredness(record: DirectoryRecord, fieldId: string): boolean {
    const key = `${record.recordId}.${fieldId}`;
    const value = record.data[fieldId];

    const isRequired = this.requiredFields.has(key)
      ? this.requiredFields.get(key)!
      : this.requiredFieldNames.includes(fieldId);

    if (!isRequired) {
      return true;
    }

    if (!hasValue(value)) {
      return false;
    }

    if (Array.isArray(value)) {
      return !!value.length;
    }

    return true;
  }

  @action.bound
  setRequiredFields(reqFields: string[]): void {
    this.requiredFieldNames = reqFields;
  }

  @action.bound
  setIsControlRequired(controlId: string, isRequired: boolean): void {
    this.requiredFields.set(controlId, isRequired);
  }

  setControlViews(views: TControlView[]): void {
    views.forEach((controlView) => this.controlViewsMap.set(controlView.fieldId, controlView));
  }

  validateField(record: DirectoryRecord, fieldId: string): boolean {
    if (!this.validateFieldRequiredness(record, fieldId)) {
      // TODO: улучшить валидацию. Массив ошибок должен наполняться посредвством отдельных методов, валидирующих разные свойства записи
      record.updateFieldsErrors({
        ...record.fieldsErrors,
        [fieldId]: [this.localizationService.t('directory:errors.validation.requiredField')],
      });

      return false;
    }

    return true;
  }

  validateRecord(record: DirectoryRecord): boolean {
    let isValid = true;
    record.updateFieldsErrors({});

    for (const fieldView of record.controlViews) {
      if (!this.validateField(record, fieldView.fieldId)) {
        isValid = false;
      }
    }

    return isValid;
  }
}
